module.exports = __webpack_public_path__ + "img/top-count-light.ddf77950.png";